// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
// import TasksTick from "../../admin/common/icons/sidebar/TasksTick";
// import RightIcon from "../../admin/common/icons/sidebar/RightIcon";
// import { Draggable } from "@fullcalendar/interaction";
// import ThreeDotRows from "../common/icons/sidebar/ThreeDotRows";
// import CalendarModal from "./CalendarModal";
// import { _Api } from "../api/_call";
// import { formatDate } from "../common/helpers/formatDate";
// import CustomerList from "./CustomerList/Index";
// import MultipleUserIconFilled, {
//   MultipleUserIcon,
// } from "../common/icons/MultipleUserIconFilled";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import SearchIcon from "@mui/icons-material/Search";

// export default function TaskSidebar(props) {
//   const {
//     taskbardata,
//     setTaskbardata,
//     getcalenderlist,
//     taskbarlistupdate,
//     setTaskbarlistupdate,
//     selectedMonth,
//   } = props;

//   const [currentEvents, setCurrentEvents] = useState([]);
//   const [tasktypes, setTasktypes] = useState({
//     type: "",
//     filter_type: [],
//   });
//   const { t } = useTranslation();
//   const draggableRef = useRef(null);

//   const selectdropdwonitems = [
//     { title: "Repair Order", type: "repair", total: 0 },
//     { title: "Custom Order", type: "custom", total: 0 },
//     { title: "Reserved Order", type: "reservee", total: 0 },
//     { title: "Purchase Order", type: "purchase", total: 0 },
//     { title: "Appointment", type: "appointment", total: 0 },
//   ];

//   const dropdownRef = useRef(null);
//   const [activeTask, setActiveTask] = useState("All");
//   const [getTaskCounts, setTaskCounts] = useState({});
//   const [showSelectedDropdown, setShowSelectedDropdown] = useState(false);
//   const [loadingdata, setLodaingdata] = useState(false);
//   const [customerCount, setCustomerCount] = useState(0);
//   const [customerData, setCustomerData] = useState();
//   const [taskBarInnerFliter, settaskBarInnerFliter] = useState(selectdropdwonitems);
//   const [dataid, setDataid] = useState({ _id: "", index: "" });
//   const listRequestIdRef = useRef(0);
//   const countRequestIdRef = useRef(0);

//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchResults, setSearchResults] = useState(null);
//   const [searchLoading, setSearchLoading] = useState(false);
//   const searchTimerRef = useRef(null);

//   const displayedEvents = searchResults !== null ? searchResults : currentEvents;

//   useEffect(() => {
//     const draggableEl = draggableRef.current;
//     if (!draggableEl) return undefined;
//     const draggable = new Draggable(draggableEl, {
//       itemSelector: ".draggable-item",
//     });
//     return () => {
//       draggable.destroy();
//     };
//   }, [currentEvents.length, activeTask]);

//   useEffect(() => {
//     getCustomerlist();
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowSelectedDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const getCustomerlist = async () => {
//     let postdata = { search: "" };
//     try {
//       let res = await _Api(postdata, `api/v1/App/calender/getCalender-customer-info`);
//       if (res?.code === 200) {
//         setCustomerData(res?.Data);
//         setCustomerCount(res?.Data?.length);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const handleSearch = (value) => {
//     setSearchQuery(value);
//     if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
//     if (!value.trim()) {
//       setSearchResults(null);
//       return;
//     }
//     searchTimerRef.current = setTimeout(async () => {
//       setSearchLoading(true);
//       try {
//         let res = await _Api(
//           { search: value.trim(), date: selectedMonth },
//           `api/v1/App/calender/search-calendar-orders`
//         );
//         if (res?.code === 200) {
//           setSearchResults(res?.data || []);
//         }
//       } catch (err) {
//         console.log(err, "search err");
//       } finally {
//         setSearchLoading(false);
//       }
//     }, 400);
//   };

//   const clearSearch = () => {
//     setSearchQuery("");
//     setSearchResults(null);
//   };

//   const buildTaskPostData = useCallback(
//     (overrides = {}) => ({
//       date: selectedMonth,
//       type: overrides.type !== undefined ? overrides.type : tasktypes?.type,
//       filter_type:
//         overrides.filter_type !== undefined
//           ? overrides.filter_type
//           : tasktypes?.filter_type || [],
//       order_type:
//         overrides.order_type !== undefined
//           ? overrides.order_type
//           : taskbardata?.clickedOrderType || "",
//     }),
//     [
//       selectedMonth,
//       tasktypes?.type,
//       tasktypes?.filter_type,
//       taskbardata?.clickedOrderType,
//     ],
//   );

//   const getCounttaskbar = useCallback(
//     async (overrides = {}) => {
//       setTaskbarlistupdate(false);
//       const requestId = ++countRequestIdRef.current;
//       try {
//         let res = await _Api(
//           buildTaskPostData(overrides),
//           `api/v1/App/calender/getCalenderData-list-counts`,
//         );
//         if (requestId !== countRequestIdRef.current) return;
//         if (res?.code === 200) {
//           setTaskCounts(res?.data);
//           let resData = res?.data?.filtersCount;
//           let updateFlitersCount = [
//             {
//               title: "Repair Order",
//               type: "repair",
//               total: resData["Repair Order"],
//             },
//             {
//               title: "Custom Order",
//               type: "custom",
//               total: resData?.["Custom Order"],
//             },
//             {
//               title: "Reserved Order",
//               type: "reservee",
//               total: resData?.["Reserved Order"],
//             },
//             {
//               title: "Purchase Order",
//               type: "purchase",
//               total: resData?.["Purchase Order"],
//             },
//             {
//               title: "Appointment",
//               type: "appointment",
//               total: resData?.Appointment,
//             },
//           ];
//           settaskBarInnerFliter(updateFlitersCount);
//         }
//       } catch (err) {
//         console.log(err, "Err");
//       }
//     },
//     [setTaskbarlistupdate, buildTaskPostData],
//   );

//   const gettaskbar = useCallback(
//     async (overrides = {}) => {
//       setTaskbarlistupdate(false);
//       setLodaingdata(true);
//       const requestId = ++listRequestIdRef.current;
//       try {
//         let res = await _Api(
//           buildTaskPostData(overrides),
//           `api/v1/App/calender/getCalenderData-list`,
//         );
//         if (requestId !== listRequestIdRef.current) return;
//         if (res?.code === 200) {
//           const rawList = Array.isArray(res?.data)
//             ? res.data
//             : Array.isArray(res?.data?.list)
//               ? res.data.list
//               : Array.isArray(res?.data?.data)
//                 ? res.data.data
//                 : [];
//           // Fresh copy so later mutations cannot drop one item from the list
//           setCurrentEvents(rawList.map((item) => item));
//         }
//       } catch (err) {
//         console.log(err, "Err");
//       } finally {
//         if (requestId === listRequestIdRef.current) {
//           setLodaingdata(false);
//         }
//       }
//     },
//     [setTaskbarlistupdate, buildTaskPostData],
//   );

//   const refreshTaskSidebar = useCallback(
//     (overrides = {}) => {
//       gettaskbar(overrides);
//       getCounttaskbar(overrides);
//     },
//     [gettaskbar, getCounttaskbar],
//   );

//   const resetToAllTasks = useCallback(() => {
//     clearSearch();
//     setActiveTask("All");
//     setTasktypes({ type: "", filter_type: [] });
//     if (typeof setTaskbardata === "function") {
//       setTaskbardata((prev) => {
//         if (!prev?.clickedOrderType) return prev;
//         return {
//           ...prev,
//           clickedOrderType: "",
//         };
//       });
//     }
//     refreshTaskSidebar({
//       type: "",
//       filter_type: [],
//       order_type: "",
//     });
//   }, [setTaskbardata, refreshTaskSidebar]);

//   useEffect(() => {
//     if (activeTask === "ShowCustomers") return;
//     refreshTaskSidebar({ type: tasktypes.type });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tasktypes.type]);

//   useEffect(() => {
//     if (activeTask === "ShowCustomers") return;
//     refreshTaskSidebar({ filter_type: tasktypes.filter_type });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tasktypes.filter_type]);

//   useEffect(() => {
//     if (!taskbardata?.runapi) return;
//     setActiveTask("All");
//     setTasktypes({ type: "", filter_type: [] });
//     refreshTaskSidebar({
//       type: "",
//       filter_type: [],
//       order_type: taskbardata?.clickedOrderType || "",
//     });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     taskbardata?.runapi,
//     taskbardata?.date,
//     taskbardata?.clickedOrderType,
//   ]);

//   useEffect(() => {
//     if (!selectedMonth) return;
//     resetToAllTasks();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedMonth]);

//   useEffect(() => {
//     if (taskbarlistupdate) {
//       refreshTaskSidebar();
//     }
//   }, [refreshTaskSidebar, taskbarlistupdate]);

//   const changeselect = (label) => {
//     setTasktypes((state) => {
//       const current = state?.filter_type || [];
//       const updatedArray = current.includes(label)
//         ? current.filter((item) => item !== label)
//         : [...current, label];
//       return {
//         ...state,
//         filter_type: updatedArray,
//       };
//     });
//   };

//   return (
//     <div
//       className={`tasksidebar makevisible ${taskbardata?.runapi ? "makevisible" : ""}`}
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         height: "calc(100vh - 225px)",
//         minHeight: 0,
//         overflow: "hidden",
//       }}
//     >

//       {/* Search bar */}
//       <div className="calend-search">
//         <div className="calend-search-inner">
//           <input
//             type="text"
//             placeholder={t("Search...")}
//             value={searchQuery}
//             onChange={(e) => handleSearch(e.target.value)}
//             className="calend-search-input"
//           />
//           {!searchQuery && <SearchIcon fontSize="small" />}
//           {searchQuery && (
//             <div className="calend-search-clear" onClick={clearSearch}>
//               ✕
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Header */}
//       <div className="tasksidebar-title">
//         <div className="tasksidebar-title-left">
//           <TasksTick />
//           <div className="mx-2">{t("Tasks")}</div>
//         </div>
//         <div className="tasksidebar-title-right">
//           {taskbardata?.date ? taskbardata?.date : formatDate(new Date())}
//         </div>
//       </div>

//       {/* Tabs */}
//       <div className="tasksidebar-tabs">
//         <div className="tasksidebar-tabs-inner" role="tablist">

//           {/* All Tasks */}
//           <div
//             onClick={() => {
//               resetToAllTasks();
//             }}
//             className={`tasksidebar-tabs-inner-item cursor-pointer ${activeTask === "All" ? "active" : ""}`}
//           >
//             <span className="tasksidebar-tabs-inner-item-text">
//               {t("All Tasks")} (
//               {searchResults !== null
//                 ? displayedEvents?.length
//                 : currentEvents?.length || getTaskCounts?.AllTask || 0}
//               )
//             </span>
//           </div>

//           {/* Overdue */}
//           <div
//             onClick={() => {
//               setActiveTask("Overdue");
//               setTasktypes((state) => ({ ...state, type: "Overdue" }));
//             }}
//             className={`tasksidebar-tabs-inner-item cursor-pointer ${activeTask === "Overdue" ? "active" : ""}`}
//           >
//             <span className="tasksidebar-tabs-inner-item-text">
//               {t("Overdue")} ({searchResults !== null ? displayedEvents?.filter((e) => e?.OverdueStatus)?.length : getTaskCounts?.Overdue})
//             </span>
//           </div>

//           {/* Completed */}
//           <div
//             onClick={() => {
//               setActiveTask("Completed");
//               setTasktypes((state) => ({ ...state, type: "Completed" }));
//             }}
//             className={`tasksidebar-tabs-inner-item cursor-pointer ${activeTask === "Completed" ? "active" : ""}`}
//           >
//             <span className="tasksidebar-tabs-inner-item-text">
//               {t("Completed")} ({searchResults !== null ? displayedEvents?.filter((e) => e?.order_status === "Completed")?.length : getTaskCounts?.Completed})
//             </span>
//           </div>

//           {/* Customers */}
//           <div
//             onClick={() => setActiveTask("ShowCustomers")}
//             className={`tasksidebar-tabs-inner-item type-customerlist cursor-pointer ${activeTask === "ShowCustomers" ? "active" : ""}`}
//           >
//             {activeTask === "ShowCustomers" ? (
//               <span className="tasksidebar-tabs-inner-item-text"><MultipleUserIconFilled /></span>
//             ) : (
//               <span className="tasksidebar-tabs-inner-item-text"><MultipleUserIcon /></span>
//             )}
//             <div className="type-customerlist-outer">
//               <div className="type-customerlist-outer-count">{customerCount}</div>
//             </div>
//           </div>

//           <div></div>
//         </div>
//       </div>

//       {/* Filter bar */}
//       {activeTask !== "ShowCustomers" ? (
//         <div
//           className="tasksidebar-filterTask d-flex justify-content-between align-items-center position-relative"
//           ref={dropdownRef}
//         >
//           <div className="tasksidebar-filterTask-left align-items-center">
//             <div className="me-2">{t("Filters")}</div>
//             <div
//               className="tasksidebar-filterTask-left-select d-flex align-items-center cursor-pointer"
//               onClick={() => setShowSelectedDropdown(!showSelectedDropdown)}
//             >
//               <span className="cursor-pointer">
//                 {t("Selected ")}{tasktypes.filter_type.length > 0 ? `(${tasktypes.filter_type.length})` : ""}
//               </span>
//               <div className={`tasksidebar-filterTask-left-icon ${showSelectedDropdown ? "open" : "close"}`}>
//                 <RightIcon />
//               </div>
//             </div>
//             <div
//               className="tooltip-area-up"
//               style={{ width: "auto", height: "auto", marginLeft: "8px" }}
//               onClick={() => {
//                 resetToAllTasks();
//               }}
//             >
//               <RefreshIcon fontSize="small" />
//               <span className="tooltip-area-up-text" style={{ color: "#fff" }}>
//                 Refresh
//               </span>
//             </div>
//           </div>

//           <div className="tasksidebar-filterTask-right">
//             {searchResults !== null ? displayedEvents?.length : currentEvents?.length}{" "}
//             {(searchResults !== null ? displayedEvents?.length : currentEvents?.length) > 1
//               ? t("Tasks")
//               : t("Task")}
//           </div>

//           {/* Filter dropdown */}
//           {showSelectedDropdown && (
//             <div className="tasksidebar-filterTask-selectdropdown">
//               <div className="tasksidebar-filterTask-selectdropdown-inner">
//                 <div className="tasksidebar-filterTask-selectdropdown-inner-title">
//                   <div className="tasksidebar-filterTask-selectdropdown-inner-title-left">
//                     {t("Quick Filters")}
//                   </div>
//                   <div
//                     className="cursor-pointer"
//                     onClick={() => {
//                       setShowSelectedDropdown(!showSelectedDropdown);
//                       setTasktypes((state) => ({ ...state, filter_type: [] }));
//                     }}
//                   >
//                     {t("Clear All")}
//                   </div>
//                 </div>
//                 <div className="tasksidebar-filterTask-selectdropdown-inner-content">
//                   {taskBarInnerFliter?.map((item, i) => (
//                     <div key={i} className="tasksidebar-filterTask-selectdropdown-inner-content-holder gap-2">
//                       <div className="com-check">
//                         <input
//                           id={item?.title}
//                           type="checkbox"
//                           checked={tasktypes?.filter_type.includes(item?.title)}
//                           onChange={() => changeselect(item?.title)}
//                           readOnly
//                         />
//                         <label htmlFor={item?.title} className="com-check-label" />
//                       </div>
//                       <div className={`tasksidebar-filterTask-selectdropdown-inner-content-holder-type ${item?.type}`}></div>
//                       <div>{item?.title} ({item?.total})</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       ) : null}

//       {/* Task list */}
//       <div
//         ref={draggableRef}
//         style={{
//           flex: 1,
//           minHeight: 0,
//           display: "flex",
//           flexDirection: "column",
//           overflow: "hidden",
//         }}
//       >
//         {loadingdata || searchLoading ? (
//           <div className="loader-holder">
//             <div id="dark_loader" className="mt-4">
//               <div className="dots">
//                 <span></span>
//                 <span></span>
//                 <span></span>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div
//             className={`tasksidebar-taskbar ${activeTask === "ShowCustomers" ? "forCustomerlist" : ""}`}
//             style={{
//               position: "relative",
//               left: "auto",
//               top: "auto",
//               height: "auto",
//               flex: 1,
//               minHeight: 0,
//               maxHeight: "100%",
//               overflow: "auto",
//               paddingBottom: 24,
//             }}
//           >
//             {activeTask === "All" || activeTask === "Overdue" || activeTask === "Completed" ? (
//               displayedEvents?.length ? (
//                 displayedEvents.map((event, index) => (
//                   <div
//                     key={`task-row-${index}-${event?._id || event?.OrderNumber || "x"}`}
//                     className="cursorhandle cursor-move"
//                   >
//                     <div
//                       className="tasksidebar-taskbar-task w-100 cursor-pointer draggable-item"
//                       data-bs-toggle="modal"
//                       data-bs-target="#showtaskmodel"
//                       data={JSON.stringify(event)}
//                       onClick={() =>
//                         setDataid({ index: index + 1, _id: event?._id })
//                       }
//                     >
//                       <div className="d-flex flex-start w-100">
//                         <div draggable="true" className="tasksidebar-taskbar-task-handleicon">
//                           <ThreeDotRows />
//                         </div>
//                         <div className={`tasksidebar-taskbar-task-type ${event?.Activity} me-2`}></div>
//                         <div className="tasksidebar-taskbar-task-inside w-100 d-block">
//                           <div className="d-flex justify-content-between align-items-center w-100">
//                             <div className={`${event?.order_status === "Completed" ? "text-dark text-decoration-line-through" : "text-dark"}`}>
//                               {event.Activity} : {event.OrderNumber}
//                             </div>
//                             <div className={event?.OverdueStatus ? "text-danger" : ""}>
//                               {event?.CompletedDate}
//                             </div>
//                           </div>
//                           <div className="d-flex justify-content-between align-items-center w-100">
//                             <div className={`${event?.order_status === "Completed" ? "text-decoration-line-through" : ""}`}>
//                               {event?.Customername}
//                             </div>
//                             <div className="text-ao">
//                               {t("SKU")}({event?.SKU}) | {t("QTY")}({event?.QTY})
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : null
//             ) : activeTask === "ShowCustomers" ? (
//               <div className="tasksidebar-taskbar-customerwrapper">
//                 <CustomerList customerData={customerData} setCustomerCount={setCustomerCount} />
//               </div>
//             ) : null}
//           </div>
//         )}
//       </div>

//       <CalendarModal
//         currentEvents={currentEvents}
//         dataid={dataid}
//         getcalenderlist={getcalenderlist}
//         gettaskbar={gettaskbar}
//       />
//     </div>
//   );
// }


import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TasksTick from "../../admin/common/icons/sidebar/TasksTick";
import RightIcon from "../../admin/common/icons/sidebar/RightIcon";
import { Draggable } from "@fullcalendar/interaction";
import ThreeDotRows from "../common/icons/sidebar/ThreeDotRows";
import CalendarModal from "./CalendarModal";
import { _Api } from "../api/_call";
import { formatDate } from "../common/helpers/formatDate";
import CustomerList from "./CustomerList/Index";
import MultipleUserIconFilled, {
  MultipleUserIcon,
} from "../common/icons/MultipleUserIconFilled";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";

export default function TaskSidebar(props) {
  const {
    taskbardata,
    setTaskbardata,
    getcalenderlist,
    taskbarlistupdate,
    setTaskbarlistupdate,
    selectedMonth,
  } = props;

  const [currentEvents, setCurrentEvents] = useState([]);
  const [tasktypes, setTasktypes] = useState({
    type: "",
    filter_type: [],
  });
  const { t } = useTranslation();
  const draggableRef = useRef(null);

  const selectdropdwonitems = [
    { title: "Repair Order", type: "repair", total: 0 },
    { title: "Custom Order", type: "custom", total: 0 },
    { title: "Reserved Order", type: "reservee", total: 0 },
    { title: "Purchase Order", type: "purchase", total: 0 },
    { title: "Appointment", type: "appointment", total: 0 },
  ];

  const dropdownRef = useRef(null);
  const [activeTask, setActiveTask] = useState("All");
  const [getTaskCounts, setTaskCounts] = useState({});
  const [showSelectedDropdown, setShowSelectedDropdown] = useState(false);
  const [loadingdata, setLodaingdata] = useState(false);
  const [customerCount, setCustomerCount] = useState(0);
  const [customerData, setCustomerData] = useState();
  const [taskBarInnerFliter, settaskBarInnerFliter] = useState(selectdropdwonitems);
  const [dataid, setDataid] = useState({ _id: "", index: "" });
  const listRequestIdRef = useRef(0);
  const countRequestIdRef = useRef(0);
  const lastFetchKeyRef = useRef("");

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const searchTimerRef = useRef(null);

  const isCompletedEvent = (event) => event?.order_status === "Completed";
  const isOverdueEvent = (event) => Boolean(event?.OverdueStatus);

  const sourceEvents = searchResults !== null ? searchResults : currentEvents;
  const displayedEvents =
    activeTask === "Overdue"
      ? sourceEvents.filter(isOverdueEvent)
      : activeTask === "Completed"
        ? sourceEvents.filter(isCompletedEvent)
        : sourceEvents;

  const allTaskCount = sourceEvents?.length || 0;
  const overdueCount = sourceEvents.filter(isOverdueEvent).length;
  const completedCount = sourceEvents.filter(isCompletedEvent).length;

  useEffect(() => {
    const draggableEl = draggableRef.current;
    if (!draggableEl) return undefined;
    const draggable = new Draggable(draggableEl, {
      itemSelector: ".draggable-item",
    });
    return () => {
      draggable.destroy();
    };
  }, [displayedEvents.length, activeTask]);

  useEffect(() => {
    getCustomerlist();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowSelectedDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCustomerlist = async () => {
    let postdata = { search: "" };
    try {
      let res = await _Api(postdata, `api/v1/App/calender/getCalender-customer-info`);
      if (res?.code === 200) {
        setCustomerData(res?.Data);
        setCustomerCount(res?.Data?.length);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    if (!value.trim()) {
      setSearchResults(null);
      return;
    }
    searchTimerRef.current = setTimeout(async () => {
      setSearchLoading(true);
      try {
        let res = await _Api(
          { search: value.trim(), date: selectedMonth },
          `api/v1/App/calender/search-calendar-orders`
        );
        if (res?.code === 200) {
          setSearchResults(res?.data || []);
        }
      } catch (err) {
        console.log(err, "search err");
      } finally {
        setSearchLoading(false);
      }
    }, 400);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setSearchResults(null);
  };

  const buildTaskPostData = useCallback(
    (overrides = {}) => ({
      date: selectedMonth,
      type: "",
      filter_type:
        overrides.filter_type !== undefined
          ? overrides.filter_type
          : tasktypes?.filter_type || [],
      order_type:
        overrides.order_type !== undefined
          ? overrides.order_type
          : taskbardata?.clickedOrderType || "",
    }),
    [
      selectedMonth,
      tasktypes?.filter_type,
      taskbardata?.clickedOrderType,
    ],
  );

  const getCounttaskbar = useCallback(
    async (overrides = {}) => {
      setTaskbarlistupdate(false);
      const requestId = ++countRequestIdRef.current;
      try {
        let res = await _Api(
          buildTaskPostData(overrides),
          `api/v1/App/calender/getCalenderData-list-counts`,
        );
        if (requestId !== countRequestIdRef.current) return;
        if (res?.code === 200) {
          setTaskCounts(res?.data);
          let resData = res?.data?.filtersCount;
          let updateFlitersCount = [
            {
              title: "Repair Order",
              type: "repair",
              total: resData["Repair Order"],
            },
            {
              title: "Custom Order",
              type: "custom",
              total: resData?.["Custom Order"],
            },
            {
              title: "Reserved Order",
              type: "reservee",
              total: resData?.["Reserved Order"],
            },
            {
              title: "Purchase Order",
              type: "purchase",
              total: resData?.["Purchase Order"],
            },
            {
              title: "Appointment",
              type: "appointment",
              total: resData?.Appointment,
            },
          ];
          settaskBarInnerFliter(updateFlitersCount);
        }
      } catch (err) {
        console.log(err, "Err");
      }
    },
    [setTaskbarlistupdate, buildTaskPostData],
  );

  const gettaskbar = useCallback(
    async (overrides = {}) => {
      setTaskbarlistupdate(false);
      setLodaingdata(true);
      const requestId = ++listRequestIdRef.current;
      try {
        let res = await _Api(
          buildTaskPostData(overrides),
          `api/v1/App/calender/getCalenderData-list`,
        );
        if (requestId !== listRequestIdRef.current) return;
        if (res?.code === 200) {
          const rawList = Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.data?.list)
              ? res.data.list
              : Array.isArray(res?.data?.data)
                ? res.data.data
                : [];
          // Fresh copy so later mutations cannot drop one item from the list
          setCurrentEvents(rawList.map((item) => item));
        }
      } catch (err) {
        console.log(err, "Err");
      } finally {
        if (requestId === listRequestIdRef.current) {
          setLodaingdata(false);
        }
      }
    },
    [setTaskbarlistupdate, buildTaskPostData],
  );

  const refreshTaskSidebar = useCallback(
    (overrides = {}) => {
      const { force = false, ...apiOverrides } = overrides;
      const requestKey = JSON.stringify(buildTaskPostData(apiOverrides));
      // Same payload is already in-flight / last fetched — skip extra list+count calls
      if (!force && requestKey === lastFetchKeyRef.current) {
        return;
      }
      lastFetchKeyRef.current = requestKey;
      gettaskbar(apiOverrides);
      getCounttaskbar(apiOverrides);
    },
    [gettaskbar, getCounttaskbar, buildTaskPostData],
  );

  const resetTaskFilters = useCallback(() => {
    setActiveTask("All");
    setTasktypes((prev) => {
      if (prev.type === "" && (!prev.filter_type || prev.filter_type.length === 0)) {
        return prev;
      }
      return { type: "", filter_type: [] };
    });
  }, []);

  const resetToAllTasks = useCallback(() => {
    clearSearch();
    resetTaskFilters();
    if (typeof setTaskbardata === "function") {
      setTaskbardata((prev) => {
        if (!prev?.clickedOrderType) return prev;
        return {
          ...prev,
          clickedOrderType: "",
        };
      });
    }
    refreshTaskSidebar({
      type: "",
      filter_type: [],
      order_type: "",
      force: true,
    });
  }, [setTaskbardata, refreshTaskSidebar, resetTaskFilters]);

  const filterTypeKey = (tasktypes.filter_type || []).join("|");

  // Fetch all-tasks list only. Overdue/Completed tabs filter this locally.
  useEffect(() => {
    if (activeTask === "ShowCustomers") return;
    refreshTaskSidebar({
      type: "",
      filter_type: tasktypes.filter_type,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterTypeKey]);

  useEffect(() => {
    if (!taskbardata?.runapi) return;
    resetTaskFilters();
    refreshTaskSidebar({
      type: "",
      filter_type: [],
      order_type: taskbardata?.clickedOrderType || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    taskbardata?.runapi,
    taskbardata?.date,
    taskbardata?.clickedOrderType,
  ]);

  useEffect(() => {
    if (!selectedMonth) return;
    clearSearch();
    resetTaskFilters();
    if (typeof setTaskbardata === "function") {
      setTaskbardata((prev) => {
        if (!prev?.clickedOrderType) return prev;
        return {
          ...prev,
          clickedOrderType: "",
        };
      });
    }
    refreshTaskSidebar({
      type: "",
      filter_type: [],
      order_type: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonth]);

  useEffect(() => {
    if (taskbarlistupdate) {
      refreshTaskSidebar({ force: true });
    }
  }, [refreshTaskSidebar, taskbarlistupdate]);

  const changeselect = (label) => {
    setTasktypes((state) => {
      const current = state?.filter_type || [];
      const updatedArray = current.includes(label)
        ? current.filter((item) => item !== label)
        : [...current, label];
      return {
        ...state,
        filter_type: updatedArray,
      };
    });
  };

  return (
    <div
      className={`tasksidebar makevisible ${taskbardata?.runapi ? "makevisible" : ""}`}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 225px)",
        minHeight: 0,
        overflow: "hidden",
      }}
    >

      {/* Search bar */}
      <div className="calend-search">
        <div className="calend-search-inner">
          <input
            type="text"
            placeholder={t("Search...")}
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            className="calend-search-input"
          />
          {!searchQuery && <SearchIcon fontSize="small" />}
          {searchQuery && (
            <div className="calend-search-clear" onClick={clearSearch}>
              ✕
            </div>
          )}
        </div>
      </div>

      {/* Header */}
      <div className="tasksidebar-title">
        <div className="tasksidebar-title-left">
          <TasksTick />
          <div className="mx-2">{t("Tasks")}</div>
        </div>
        <div className="tasksidebar-title-right">
          {taskbardata?.date ? taskbardata?.date : formatDate(new Date())}
        </div>
      </div>

      {/* Tabs */}
      <div className="tasksidebar-tabs">
        <div className="tasksidebar-tabs-inner" role="tablist">

          {/* All Tasks */}
          <div
            onClick={() => setActiveTask("All")}
            className={`tasksidebar-tabs-inner-item cursor-pointer ${activeTask === "All" ? "active" : ""}`}
          >
            <span className="tasksidebar-tabs-inner-item-text">
              {t("All Tasks")} ({allTaskCount})
            </span>
          </div>

          {/* Overdue */}
          <div
            onClick={() => setActiveTask("Overdue")}
            className={`tasksidebar-tabs-inner-item cursor-pointer ${activeTask === "Overdue" ? "active" : ""}`}
          >
            <span className="tasksidebar-tabs-inner-item-text">
              {t("Overdue")} ({overdueCount})
            </span>
          </div>

          {/* Completed */}
          <div
            onClick={() => setActiveTask("Completed")}
            className={`tasksidebar-tabs-inner-item cursor-pointer ${activeTask === "Completed" ? "active" : ""}`}
          >
            <span className="tasksidebar-tabs-inner-item-text">
              {t("Completed")} ({completedCount})
            </span>
          </div>

          {/* Customers */}
          <div
            onClick={() => setActiveTask("ShowCustomers")}
            className={`tasksidebar-tabs-inner-item type-customerlist cursor-pointer ${activeTask === "ShowCustomers" ? "active" : ""}`}
          >
            {activeTask === "ShowCustomers" ? (
              <span className="tasksidebar-tabs-inner-item-text"><MultipleUserIconFilled /></span>
            ) : (
              <span className="tasksidebar-tabs-inner-item-text"><MultipleUserIcon /></span>
            )}
            <div className="type-customerlist-outer">
              <div className="type-customerlist-outer-count">{customerCount}</div>
            </div>
          </div>

          <div></div>
        </div>
      </div>

      {/* Filter bar */}
      {activeTask !== "ShowCustomers" ? (
        <div
          className="tasksidebar-filterTask d-flex justify-content-between align-items-center position-relative"
          ref={dropdownRef}
        >
          <div className="tasksidebar-filterTask-left align-items-center">
            <div className="me-2">{t("Filters")}</div>
            <div
              className="tasksidebar-filterTask-left-select d-flex align-items-center cursor-pointer"
              onClick={() => setShowSelectedDropdown(!showSelectedDropdown)}
            >
              <span className="cursor-pointer">
                {t("Selected ")}{tasktypes.filter_type.length > 0 ? `(${tasktypes.filter_type.length})` : ""}
              </span>
              <div className={`tasksidebar-filterTask-left-icon ${showSelectedDropdown ? "open" : "close"}`}>
                <RightIcon />
              </div>
            </div>
            <div
              className="tooltip-area-up"
              style={{ width: "auto", height: "auto", marginLeft: "8px" }}
              onClick={() => {
                resetToAllTasks();
              }}
            >
              <RefreshIcon fontSize="small" />
              <span className="tooltip-area-up-text" style={{ color: "#fff" }}>
                Refresh
              </span>
            </div>
          </div>

          <div className="tasksidebar-filterTask-right">
            {displayedEvents?.length || 0}{" "}
            {(displayedEvents?.length || 0) > 1 ? t("Tasks") : t("Task")}
          </div>

          {/* Filter dropdown */}
          {showSelectedDropdown && (
            <div className="tasksidebar-filterTask-selectdropdown">
              <div className="tasksidebar-filterTask-selectdropdown-inner">
                <div className="tasksidebar-filterTask-selectdropdown-inner-title">
                  <div className="tasksidebar-filterTask-selectdropdown-inner-title-left">
                    {t("Quick Filters")}
                  </div>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setShowSelectedDropdown(!showSelectedDropdown);
                      setTasktypes((state) => ({ ...state, filter_type: [] }));
                    }}
                  >
                    {t("Clear All")}
                  </div>
                </div>
                <div className="tasksidebar-filterTask-selectdropdown-inner-content">
                  {taskBarInnerFliter?.map((item, i) => (
                    <div key={i} className="tasksidebar-filterTask-selectdropdown-inner-content-holder gap-2">
                      <div className="com-check">
                        <input
                          id={item?.title}
                          type="checkbox"
                          checked={tasktypes?.filter_type.includes(item?.title)}
                          onChange={() => changeselect(item?.title)}
                          readOnly
                        />
                        <label htmlFor={item?.title} className="com-check-label" />
                      </div>
                      <div className={`tasksidebar-filterTask-selectdropdown-inner-content-holder-type ${item?.type}`}></div>
                      <div>{item?.title} ({item?.total})</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : null}

      {/* Task list */}
      <div
        ref={draggableRef}
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {loadingdata || searchLoading ? (
          <div className="loader-holder">
            <div id="dark_loader" className="mt-4">
              <div className="dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={`tasksidebar-taskbar ${activeTask === "ShowCustomers" ? "forCustomerlist" : ""}`}
            style={{
              position: "relative",
              left: "auto",
              top: "auto",
              height: "auto",
              flex: 1,
              minHeight: 0,
              maxHeight: "100%",
              overflow: "auto",
              paddingBottom: 24,
            }}
          >
            {activeTask === "All" || activeTask === "Overdue" || activeTask === "Completed" ? (
              displayedEvents?.length ? (
                displayedEvents.map((event, index) => (
                  <div
                    key={`task-row-${index}-${event?._id || event?.OrderNumber || "x"}`}
                    className="cursorhandle cursor-move"
                  >
                    <div
                      className="tasksidebar-taskbar-task w-100 cursor-pointer draggable-item"
                      data-bs-toggle="modal"
                      data-bs-target="#showtaskmodel"
                      data={JSON.stringify(event)}
                      onClick={() =>
                        setDataid({ index: index + 1, _id: event?._id })
                      }
                    >
                      <div className="d-flex flex-start w-100">
                        <div draggable="true" className="tasksidebar-taskbar-task-handleicon">
                          <ThreeDotRows />
                        </div>
                        <div className={`tasksidebar-taskbar-task-type ${event?.Activity} me-2`}></div>
                        <div className="tasksidebar-taskbar-task-inside w-100 d-block">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div className={`${event?.order_status === "Completed" ? "text-dark text-decoration-line-through" : "text-dark"}`}>
                              {event.Activity} : {event.OrderNumber}
                            </div>
                            <div className={event?.OverdueStatus ? "text-danger" : ""}>
                              {event?.CompletedDate}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <div className={`${event?.order_status === "Completed" ? "text-decoration-line-through" : ""}`}>
                              {event?.Customername}
                            </div>
                            <div className="text-ao">
                              {t("SKU")}({event?.SKU}) | {t("QTY")}({event?.QTY})
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : null
            ) : activeTask === "ShowCustomers" ? (
              <div className="tasksidebar-taskbar-customerwrapper">
                <CustomerList customerData={customerData} setCustomerCount={setCustomerCount} />
              </div>
            ) : null}
          </div>
        )}
      </div>

      <CalendarModal
        currentEvents={currentEvents}
        dataid={dataid}
        getcalenderlist={getcalenderlist}
        gettaskbar={gettaskbar}
      />
    </div>
  );
}